module.exports = __webpack_public_path__ + "img/evaluatorred.ad55da9e.svg";